<template>
  <div>
    <b-card>
      <div class="organism-history_header card-padding">
        <span class="header__label">Configuration History</span>
      </div>
      <div class="filter-container card-padding pt-0">
        <div class="row mt-0">
          <div class="col-12 col-sm-6">
            <atom-select
              v-model="filterList.node"
              title="Node Name"
              placeholder="All Node"
              label="nodeValue"
              :option="nodeOptions"
              :isAppendToBody="false"
              :isEnableProper="false"
            ></atom-select>
          </div>
          <div class="col-12 col-sm-6 mt-1 mt-sm-0">
            <atom-select
              v-model="filterList.version"
              title="Versions"
              placeholder="All Versions"
              :isDisable="filterList.node === null"
              :option="nodeVersionOptions"
              :isAppendToBody="false"
              :isEnableProper="false"
            ></atom-select>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 w-100">
            <div>
              <atom-datepicker
                datepickerId="molecule-date-picker-period--start"
                title="Start Date"
                v-model="filterList.dateTime.start"
                :maxDate="
                  filterList.dateTime.end
                    ? filterList.dateTime.end
                    : filterList.dateTime.now
                "
                type="dateNtime"
                placeholder="Select Start Date"
                class="molecule-date-picker-period--start"
                :isDisabled="!filterList.isEnableDate"
              ></atom-datepicker>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 w-100 mt-1 mt-sm-0">
            <div>
              <atom-datepicker
                datepickerId="molecule-date-picker-period--en"
                title="End Date"
                v-model="filterList.dateTime.end"
                :minDate="filterList.dateTime.start"
                :maxDate="filterList.dateTime.now"
                type="dateNtime"
                placeholder="Select End Date"
                class="molecule-date-picker-period--end"
                :isDisabled="!filterList.isEnableDate"
              ></atom-datepicker>
            </div>
          </div>
          <div
            class="col-12 col-md-4 col-lg-3 d-flex mt-1 mt-md-0 d-flex justify-content-end justify-content-md-start"
          >
            <div class="d-flex flex-column">
              <label>Filter Date?</label>
              <atom-switch
                v-model="filterList.isEnableDate"
                class="filter__switch"
              ></atom-switch>
            </div>
            <div class="d-flex align-items-end">
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                class="search__button ml-2"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div name="table-section" v-if="items.length">
        <div class="row mt-3">
          <div class="col-12">
            <b-table
              sticky-header
              responsive
              :items="items"
              :fields="fields"
              :hover="true"
            >
              <template #cell(timestamp)="data">
                <span>{{ data.value.date }} </span> <br />
                <span class="sub-header">{{ data.value.time }}</span>
              </template>
              <template #cell(nodeName)="data">
                <div class="header">{{ data.value }}</div>
              </template>
              <template #cell(version)="data">
                <b-badge pill variant="light-primary" class="badge--width">
                  Version {{ data.value }}
                </b-badge>
              </template>
              <template #cell(configButton)="data">
                <div class="d-flex justify-content-end">
                  <atom-button
                    buttonId="button-view"
                    buttonStyle="border"
                    @click="viewConfig(data)"
                    class="mr-1"
                    >View</atom-button
                  >
                  <atom-button
                    buttonId="button-compare"
                    buttonStyle="border"
                    @click="compareHistory(data)"
                    >Compare</atom-button
                  >
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="row card-padding">
          <div class="col-6">Showing {{ items.length }} entries</div>
          <div class="col-6 d-flex justify-content-end">
            <b-pagination
              v-model="filterList.currentPage"
              :total-rows="filterList.total"
              :per-page="perPage"
              size="sm"
              class="my-0"
            ></b-pagination>
          </div>
        </div>
      </div>
      <div v-else class="d-flex flex-column align-items-center p-3">
        <feather-icon
          icon="CloudOffIcon"
          class="empty-data__icon"
        ></feather-icon>
        <label class="empty-data__text--title">No Data</label>
      </div>
    </b-card>
    <footer style="height: 28px"></footer>
    <!-- ? Modal Section Start -->
    <molecule-modal-dialog
      modalId="modal-configuration-detail"
      :textTitle="`${targetNodeData.nodeName} (version ${targetNodeData.version})`"
      :textSubtitle="`Timestamp: ${formatDateTime(targetNodeData.timestamp)}`"
      :isButtonLeft="false"
      :isButtonRight="false"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonRight="onClickCloseFromModal"
    >
      <template #body>
        <div class="mt-1 w-95">
          <div
            name="topic-and-button-wrapper"
            class="d-flex justify-content-between align-items-end mb-2"
          >
            <div name="LHS">
              <span class="modal-topic--text">Configuration Detail</span>
            </div>
            <div name="RHS" style="display: flex">
              <atom-button
                buttonId="copy-generated-config"
                buttonStyle="border"
                class="mr-1"
                @click="onClickCopyConfigDetail"
              >
                <span v-if="screenWidth > 500" class="button-text">Copy</span>
                <feather-icon v-else icon="CopyIcon"></feather-icon>
              </atom-button>
              <atom-button
                buttonId="download-generated-config"
                buttonStyle="border"
                @click="onClickDownloadConfigDetail"
              >
                <span v-if="screenWidth > 500" class="button-text"
                  >Download</span
                >
                <feather-icon v-else icon="DownloadIcon"></feather-icon>
              </atom-button>
            </div>
          </div>
          <div name="generated-config__wrapper">
            <prism-editor
              v-model="selectedConfigData"
              class="text-area-with-line-number custom-max-height"
              readonly
              :lineNumbers="screenWidth > 1080 ? true : false"
              :highlight="highlighter"
            ></prism-editor>
          </div>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- ? Modal Section End -->
    <textarea
      v-on:focus="$event.target.select()"
      readonly
      ref="copyConfigHistoryTextBox"
      class="hidden-textbox"
      :value="selectedConfigData"
    />
  </div>
</template>

<script>
// import Prism Editor
import { PrismEditor } from "vue-prism-editor"
import "vue-prism-editor/dist/prismeditor.min.css"

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core"
import "prismjs/components/prism-clike"
import "prismjs/components/prism-javascript"
import "prismjs/themes/prism-tomorrow.css" // import syntax highlighting styles

import { BCard, BTable, BBadge, BPagination } from "bootstrap-vue"
import { DateTime } from "luxon"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import VueScreenSize from "vue-screen-size"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  name: "OrganismConfigurationHistory",
  components: {
    BCard,
    BTable,
    BPagination,
    BBadge,
    AtomSelect,
    AtomDatepicker,
    AtomSwitch,
    AtomButton,
    MoleculeModalDialog,
    PrismEditor,
  },
  mixins: [mixins, mixinsValidator, VueScreenSize.VueScreenSizeMixin],
  props: {
    filterList: {
      type: Object,
      required: true,
    },
    nodeOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    nodeVersionOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    selectedConfigData: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      modalId: null,
      perPage: 10,
      targetNodeData: {
        nodeName: "",
        version: 0,
        timestamp: "",
      },
    }
  },
  computed: {
    screenWidth() {
      return this.$vssWidth
    },
  },
  watch: {
    "filterList.node": {
      deep: true,
      handler() {
        if (this.filterList.node?.nodeId) {
          const nodeId = this.filterList.node?.nodeId
          this.$emit("onUpdateFilterSelectedNode", nodeId)
        }
      },
    },
    "filterList.currentPage": {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit("onUpdateCurrentPage", this.filterList)
        }
      },
    },
  },
  methods: {
    formatDateTime(datetime) {
      if (this.hasString(datetime)) {
        return DateTime.fromISO(datetime).toFormat("dd/MM/yyyy HH:mm:ss")
      } else {
        return datetime
      }
    },

    highlighter(code) {
      return code // languages.<insert language> to return html with markup
    },

    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },

    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },

    compareHistory(data) {
      this.$emit("clickCompare", data.item)
    },

    viewConfig(data) {
      this.targetNodeData.nodeName = data.item.nodeName
      this.targetNodeData.version = data.item.version
      this.targetNodeData.timestamp = data.item.timeStamp
      this.$emit("onSelectedConfigData", data.item)
      this.openModal("modal-configuration-detail")
    },

    onClickCopyConfigDetail() {
      this.$refs.copyConfigHistoryTextBox.focus()
      document.execCommand("copy")
      this.toastSuccess("Copy successfully")
    },

    onClickDownloadConfigDetail() {
      let blob = new Blob([this.selectedConfigData], { type: "text/plain" })
      let link = document.createElement("a")
      link.href = window.URL.createObjectURL(blob)
      link.download = `${this.targetNodeData.nodeName}_version_${this.targetNodeData.version}.txt`
      link.click()
      this.toastSuccess("Download successfully")
    },

    onClickCloseFromModal() {
      this.closeModal()
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-history_header {
  display: flex;
  flex-direction: column;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.filter-container {
  border-bottom: 1px solid #e9ecef;
}

.header {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;

  overflow-wrap: break-word;
  word-break: break-word;
}

.sub-header {
  font-weight: 400;
  color: #b9b9c3;
}

.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.filter__switch {
  padding-top: 10px;
  height: fit-content;
}

.priority__crirical {
  font-weight: 600;
  font-size: 14px;
  color: #ea5455;
}

.priority__high {
  font-size: 14px;
  color: #ea5455;
}

.priority__medium {
  font-size: 14px;
  color: #ff9f43;
}

.priority__low {
  font-size: 14px;
  color: #28c76f;
}

.empty-data__icon {
  width: 100px;
  height: 100px;
}

.empty-data__text--title {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
  margin-top: 20px;
}

.custom-max-height {
  max-height: 500px;
  overflow-y: auto;
}

.hidden-textbox {
  position: absolute;
  top: -99999px;
}

.modal-topic--text {
  font-size: 12px;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}

@media screen and (min-width: 576px) {
  .organism-history_header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .modal-topic--text {
    font-size: 14px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
